<div class="container">
    <video #video
           [controls]="false"
           autoplay
           playsinline
           preload="auto">
    </video>
</div>
